<template>
  <div>
    <DataNavigation></DataNavigation>
    <VipPrompt :pageModal="page_modal" @pagecancel="pageCancel"></VipPrompt>
    <div class="index_content">
      <Layout>
        <Sider width="208">
          <div class="right_column">
            <p class="top-tip">产业园区</p>
            <div class="keyword-input">
              <Input search enter-button :placeholder="search_phd" v-model="search_ipt" @on-search="handleSearch" />
            </div>
            <div class="rigit_title">
              <span>筛选</span>
              <Dropdown trigger="click" placement="bottom-start" @on-visible-change="handleDropdown" @on-click="haddleScreenDropdown">
                <a href="javascript:void(0)">
                  <span>{{screen_active}}</span>
                  <Icon type="md-arrow-dropup" v-if="drop_val" />
                  <Icon type="md-arrow-dropdown" v-else />
                </a>
                <DropdownMenu slot="list">
                  <DropdownItem v-for="(item, sindex) in screen_dropdown" :name="item" :selected="screen_active == item" :key="sindex">{{item}}</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
            <div class="rigit_content">
              <div class="screen_ul">
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '园区类别'">
                  <div class="screen_tle" @click="screenTle.parkTypes = !screenTle.parkTypes">
                    <span>园区类别</span>
                    <Icon type="md-add" v-if="!screenTle.parkTypes" />
                    <Icon type="md-remove" v-else />
                  </div>
                  <div class="screen_cnt" v-show="screenTle.parkTypes">
                    <Checkbox v-model="checkAll.parkTypes" class="all_option" :disabled="checkAll.parkTypes" @on-change="handleCheckAll('parkTypes')">
                      <span>不限</span>
                    </Checkbox>
                    <CheckboxGroup v-model="params.parkTypes" @on-change="handleChangeOption($event, 'parkTypes')">
                      <Checkbox v-for="(item,index) in entityParkType" :label="item" :key="index">
                        <span>{{item}}({{item | dealName(parkTypeCount, 'name', 'count', '0')}})</span>
                      </Checkbox>
                    </CheckboxGroup>
                  </div>
                </div>
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '核准部门'">
                  <div class="screen_tle" @click="screenTle.govs = !screenTle.govs">
                    <span>核准部门</span>
                    <Icon type="md-add" v-if="!screenTle.govs" />
                    <Icon type="md-remove" v-else />
                  </div>
                  <div class="screen_cnt" v-show="screenTle.govs">
                    <Checkbox v-model="checkAll.govs" class="all_option" :disabled="checkAll.govs" @on-change="handleCheckAll('govs')">
                      <span>不限</span>
                    </Checkbox>
                    <CheckboxGroup v-model="params.govs" @on-change="handleChangeOption($event, 'govs')">
                      <Checkbox v-for="(item,index) in entityParkGov" :label="item" :key="index">
                        <span>{{item}}({{item | dealName(govCount, 'name', 'count', '0')}})</span>
                      </Checkbox>
                    </CheckboxGroup>
                  </div>
                </div>
                <div class="screen_li" v-show="screen_active === '全部' || screen_active === '地区选择'">
                  <div class="screen_tle" @click="screenTle.addressIds = !screenTle.addressIds">
                    <span>地区选择</span>
                    <Icon type="md-add" v-if="!screenTle.addressIds" />
                    <Icon type="md-remove" v-else />
                  </div>
                  <div class="screen_cnt" v-show="screenTle.addressIds">
                    <RadioGroup v-model="params.domestic" vertical @on-change="handleChangeDomestic">
                      <Radio :label="null"><span>不限</span></Radio>
                      <Radio :label="0"><span>国外({{0 | dealName(domesticCount, 'id', 'count')}})</span></Radio>
                      <div class="sec_options" v-if="params.domestic == 0">
                        <Checkbox v-model="checkAll.addressIds" class="all_option" :disabled="checkAll.addressIds" @on-change="handleCheckAll('addressIds')">
                          <span>全部</span>
                        </Checkbox>
                        <CheckboxGroup v-model="params.addressIds" @on-change="handleChangeOption($event, 'addressIds')">
                          <Checkbox v-for="(item,index) in foreign_country" :label="item.id" :key="index" v-show="index < 10 || showAllAddress">
                            <span>{{item.name}}</span>
                          </Checkbox>
                        </CheckboxGroup>
                        <span class="more_sel" @click="showAllAddress = !showAllAddress">
                          <template v-if="!showAllAddress">查看更多</template>
                          <template v-else>收起更多</template>
                        </span>
                      </div>
                      <Radio :label="1" class="bro"><span>国内({{1 | dealName(domesticCount, 'id', 'count', '0')}})</span></Radio>
                      <div class="sec_options" v-if="params.domestic == 1">
                        <Checkbox v-model="checkAll.addressIds" class="all_option" :disabled="checkAll.addressIds" @on-change="handleCheckAll('addressIds')">
                          <span>全部</span>
                        </Checkbox>
                        <CheckboxGroup v-model="params.addressIds" @on-change="handleChangeOption($event, 'addressIds')">
                          <Checkbox v-for="(item,index) in city" :label="item.id" :key="index" v-show="index < 10 || showAllAddress">
                            <span>{{item.name}}</span>
                          </Checkbox>
                        </CheckboxGroup>
                        <span class="more_sel" @click="showAllAddress = !showAllAddress">
                          <template v-if="!showAllAddress">查看更多</template>
                          <template v-else>收起更多</template>
                        </span>
                      </div>
                    </RadioGroup>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Sider>
        <Content>
          <div class="top-tip">全部<span v-if="!listLoading">（{{total}}）</span></div>
          <div class="sel_opt" v-if="haveOption && haveOption.length > 0">
            <div class="sel_tle">已选条件</div>
            <div class="sel_cnt">
              <span v-for="(item,index) in haveOption" :key="index" @click="handleCancelOption(item)">{{item.name}}
                <Icon type="md-close" />
              </span>
            </div>
            <div class="sel_clear">
              <span @click="handleClearOption"><i class="iconfont">&#xe63e;</i>清空筛选</span>
            </div>
          </div>
          <div class="list_div">
            <Table :columns="listColumns" :data="listData"></Table>
            <div class="page clear" v-if="total > 10">
              <Page :total="total" :page-size="10" :current="params.page" class="page_list" show-total show-elevator ref="pages" @on-change="handleChangePage" />
            </div>
            <Spin fix v-if="listLoading">
              <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
              <div>Loading</div>
            </Spin>
          </div>
        </Content>
      </Layout>
    </div>
  </div>
</template>

<script>
import { idxOf, remove, removeArrObj } from 'js/findIndex'
import { getAppMeta, parkList, parkListCount } from '../../service'
import { listMixins } from 'js/listMixins'
import { userInfo } from 'js/userInfo'
import Nothing from '@/components/Nothing.vue'
import DataNavigation from './components/DataNavigation.vue'
import VipPrompt from '@/components/VipPrompt.vue'
import EntityAttention from './components/EntityAttention.vue'
import SearchPrompt from './components/SearchPrompt.vue'
import filter from 'js/filter'

export default {
  inject: ['login'],
  mixins: [listMixins, userInfo],
  components: {
    Nothing,
    DataNavigation,
    VipPrompt,
    EntityAttention,
    SearchPrompt,
  },
  data() {
    return {
      listName: '机构',
      listColumns: [
        {
          title: '机构名称',
          minWidth: 180,
          render: (h, params) => {
            return h(
              'div',
              {
                class: {
                  company: true,
                },
              },
              [
                h(
                  'div',
                  {
                    class: {
                      logo_img: true,
                    },
                    on: {
                      click: () => {
                        this.goEntityDetail(params.row.uid, 4)
                      },
                    },
                  },
                  [
                    h('img', {
                      attrs: {
                        src: filter.logo_show(params.row.logoPath),
                      },
                    }),
                  ]
                ),
                h(
                  'div',
                  {
                    class: {
                      company_name: true,
                    },
                    style: {
                      width: '150px',
                    },
                  },
                  [
                    h('p', [
                      h(
                        'a',
                        {
                          on: {
                            click: () => {
                              this.goEntityDetail(params.row.uid, 4)
                            },
                          },
                        },
                        params.row.shortName
                      ),
                    ]),
                  ]
                ),
              ]
            )
          },
        },
        {
          title: '地区',
          width: 140,
          render: (h, params) => {
            return h('span', filter.addressDeal(params.row.addressId, '3'))
          },
        },
        {
          title: '类别',
          width: 180,
          render: (h, params) => {
            return h('span', filter.empty(params.row.parkType))
          },
        },
        {
          title: '批准部门',
          width: 140,
          render: (h, params) => {
            return h('span', filter.empty(params.row.gov))
          },
        },
        {
          title: '主要产业',
          minWidth: 180,
          render: (h, params) => {
            return h('span', filter.empty(params.row.majorDetail))
          },
        },
      ],
      params: {
        addressIds: [],
        domestic: null,
        getCount: true,
        govs: [],
        keyword: '',
        page: 1,
        parkTypes: [],
        size: 10,
      },
      screen_dropdown: ['全部', '园区类别', '核准部门', '地区选择'],
      //筛选条件是否展开
      screenTle: {
        addressIds: false,
        govs: false,
        parkTypes: false,
      },
      //不限
      checkAll: {
        addressIds: true,
        govs: false,
        parkTypes: false,
      },
      position_id: '99',
      entityParkGov: [],
      entityParkType: [],

      domesticCount: [],
      govCount: [],
      parkTypeCount: [],
    }
  },
  computed: {
    haveOption() {
      let optionaddressIds = [],
        optionKeyWord = [],
        optionDomestic = [],
        optiongovs = [],
        optionparkTypes = []
      this.params.govs.map((a) => {
        optiongovs.push({
          type: 'govs',
          name: a,
          value: a,
        })
      })
      this.params.parkTypes.map((a) => {
        optionparkTypes.push({
          type: 'parkTypes',
          name: a,
          value: a,
        })
      })
      if (this.params.domestic !== null) {
        optionDomestic = {
          type: 'domestic',
          name: this.params.domestic == 0 ? '国外' : '国内',
          value: this.params.domestic,
        }
      }
      if (this.params.keyword !== '') {
        optionKeyWord = {
          type: 'keyword',
          name: this.params.keyword,
          value: this.params.keyword,
        }
      }
      this.params.addressIds.map((a) => {
        optionaddressIds.push({
          type: 'addressIds',
          name: filter.deal(a, 'address'),
          value: a,
        })
      })

      return [].concat(optionKeyWord, optionDomestic, optionaddressIds, optiongovs, optionparkTypes)
    },
  },
  methods: {
    async getAppMeta() {
      let res = await getAppMeta(
        {
          metaNameList: ['entityParkMeta'],
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
      if (res.code == 0) {
        this.$set(this.$data, 'entityParkGov', res.data.entityParkGov)
        this.$set(this.$data, 'entityParkType', res.data.entityParkType)
      }
    },
    async getParkListCount() {
      let res = await parkListCount({}, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.code == 0) {
        this.$set(this.$data, 'domesticCount', res.data.domesticCount)
        this.$set(this.$data, 'govCount', res.data.govCount)
        this.$set(this.$data, 'parkTypeCount', res.data.parkTypeCount)
      }
    },

    /**
     * 改变地域事件
     */
    handleChangeDomestic() {
      if (!this.listLoading) {
        this.params.addressIds = []
        this.checkAll.addressIds = true
        this.showAllAddress = false
        this.params.page = 1
        this.getEntityList()
      } else {
        this.$Message.loading('数据正在加载中，请勿重复操作！')
      }
    },
    /**
     * 获取公司列表
     */
    async getEntityList() {
      this.listLoading = true
      let res = await parkList(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      this.listLoading = false
      if (res.code == 0) {
        this.$set(this.$data, 'listData', res.data.entityParkDtoList)
        this.$set(this.$data, 'total', res.data.count)
      } else {
        this.$Message.error(res.msg)
      }
    },
    /**
     * 清空已选择项
     */
    handleClearOption() {
      this.params = {
        addressIds: [],
        domestic: null,
        getCount: true,
        govs: [],
        keyword: '',
        page: 1,
        parkTypes: [],
        size: 10,
      },
      this.checkAll = {
        addressIds: true,
        govs: false,
        parkTypes: false,
      }
      this.search_ipt = ''
      this.params.page = 1
      this.getEntityList()
    },
  },
  created() {
    this.getAppMeta()
    this.getParkListCount()
    this.getEntityList()
  },
  mounted() {
    this.$nextTick(() => {
      window.onscroll = () => {
        this.listenerScroll('right_column', 10)
      }
      window.onresize = () => {
        this.listenerScroll('right_column', 10)
      }
    })
  },
  beforeDestroy() {
    window.onscroll = ''
    window.onresize = ''
  },
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/dataList.stylus'
</style>
